
import { Options, Vue } from 'vue-class-component'

@Options({})
export default class About extends Vue {

    created(): void {
        this.$meta.use({
            title: 'About Us | StatHub.gg',
            og: {
                image: '/img/icons/android-chrome-maskable-192x192.png',
                description: 'StatHub.gg - About Us.'
            }
        })
    }

}
